import axios from 'axios'
import FileDownload from'js-file-download'

const api = {

  async getChain () {
    return await axios.get('/api/kk/chains/current').then(response => response.data)
  },

  async getPharmacies () {
    return await axios.get('/api/kk/pharmacies').then(response => response.data)
  },

  async getPharmacy (id) {
    return await axios.get('/api/kk/pharmacies/' + id).then(response => response.data)
  },

  async getElectionPeriod () {
    return await axios.get('/api/kk/electionPeriods').then(response => response.data)
  },

  export () {
    axios.get('/api/kk/pharmacies/export', { responseType: 'blob' }).then((response) => {
      FileDownload(response.data, 'praksisplasser.xlsx')
    })
  },

}

export default api